module.exports = __webpack_public_path__ + "static/fonts/URWDINArabicMedium.b389700.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/URWDINArabicMedium.ttf
// module id = ZBlo
// module chunks = 1